import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  notifications: {
    width: "100%",
    maxWidth: "700px",
    maxHeight: "300px",
    position: "fixed",
    right: "56px",
    bottom: "36px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
}));
